import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const STATUS = {
  submitted: "bg-zinc-100 text-zinc-700 border-zinc-200",
  in_review: "bg-amber-50 text-amber-700 border-amber-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  denied: "bg-rose-50 text-rose-700 border-rose-200",
};

export default function ArcTrackerPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/arc"); setItems(data.items); })(); }, []);

  return (
    <div>
      <PageHeader eyebrow="Committee" title="ARC Tracker" subtitle="Watch each request move through review." />
      <div className="space-y-4">
        {items.map((a) => (
          <Card key={a.id} className="p-5 bg-white">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <div className="overline">{a.category}</div>
                <div className="text-lg font-semibold font-display mt-1 truncate">{a.title}</div>
                <div className="text-sm text-zinc-600 mt-1">{a.description}</div>
              </div>
              <Badge variant="outline" className={STATUS[a.status] || "bg-zinc-50"}>{a.status.replaceAll("_"," ")}</Badge>
            </div>
            <div className="mt-4">
              <div className="flex items-center gap-2 text-xs text-zinc-500">
                <Step done label="Submitted" />
                <Step done={["in_review","approved","denied"].includes(a.status)} label="In review" />
                <Step done={a.status === "approved"} label="Approved" positive />
                <Step done={a.status === "denied"} label="Denied" negative />
              </div>
            </div>
          </Card>
        ))}
        {items.length === 0 && <div className="text-sm text-muted-foreground">No ARC requests yet.</div>}
      </div>
    </div>
  );
}

function Step({ label, done, positive, negative }) {
  const bg = done ? (positive ? "bg-emerald-500" : negative ? "bg-rose-500" : "bg-zinc-900") : "bg-zinc-200";
  return (
    <div className="flex items-center gap-2">
      <div className={"h-2 w-2 rounded-full " + bg} />
      <span className={done ? "text-zinc-800" : "text-zinc-400"}>{label}</span>
      <div className="mx-2 h-px w-6 bg-zinc-200 last:hidden" />
    </div>
  );
}
